<template>
	<div class="container mt-5 custom-container">
		<div class="row">
			<div class="col-12">
				<div class="card">
					<!-- Header Section -->
					<div class="card-header">
						<div class="row">
							<div class="col-md-4">
								<img
									:src="
										urlGenerator(
											'images/logo_clc_new_landscape.png'
										)
									"
									alt="logo"
									width="200"
									class="mt-3 ml-3"
								/>
							</div>
							<div class="col-md-4"></div>
							<div class="col-md-4 d-flex align-items-center">
								<h2 class="mt-3 font-weight-bold display-5">
									FEES NOTICE
								</h2>
							</div>
						</div>
						<div class="my-2 mx-4">
							<hr style="border: 2px solid" />
						</div>
					</div>

					<!-- Body Section -->
					<div class="card-body">
						<!-- Header Information  -->
						<div class="row">
							<div class="col-6">
								<table class="table table-sm table-borderless">
									<tr>
										<td width="35%"><b>Notice To</b></td>
										<td width="10%">:</td>
										<td>
											{{
												this.feesNoticeHeaderData
													.notice_to
											}}
										</td>
									</tr>
									<tr>
										<td width="35%">Student Name</td>
										<td width="10%">:</td>
										<td>
											{{
												this.feesNoticeHeaderData
													.customer_name
											}}
										</td>
									</tr>
									<tr>
										<td width="35%">Term Period</td>
										<td width="10%">:</td>
										<td>
											{{
												this.feesNoticeHeaderData
													.date_start
											}}
											-
											{{
												this.feesNoticeHeaderData
													.date_end
											}}
										</td>
									</tr>
									<tr>
										<td width="35%">Start Date</td>
										<td width="10%">:</td>
										<td>
											{{
												this.feesNoticeHeaderData
													.date_start
											}}
										</td>
									</tr>
									<tr>
										<td width="35%">End Date</td>
										<td width="10%">:</td>
										<td>
											{{
												this.feesNoticeHeaderData
													.date_end
											}}
										</td>
									</tr>
								</table>
							</div>
							<div class="col-6">
								<table class="table table-sm table-borderless">
									<tr>
										<td width="35%">
											<b>Fees Notice No</b>
										</td>
										<td width="10%">:</td>
										<td>
											{{
												this.feesNoticeHeaderData
													.invoice_no
											}}
										</td>
									</tr>
									<tr>
										<td width="35%">Print Date</td>
										<td width="10%">:</td>
										<td>
											{{
												this.feesNoticeHeaderData
													.print_date
											}}
										</td>
									</tr>
									<tr>
										<td width="35%">CLC Centre</td>
										<td width="10%">:</td>
										<td>
											{{
												this.feesNoticeHeaderData
													.center_id?.name
											}}
										</td>
									</tr>
									<tr>
										<td width="35%">Amount Due</td>
										<td width="10%">:</td>
										<td>
											{{
												this.feesNoticeHeaderData
													.sub_total
											}}
										</td>
									</tr>
									<tr>
										<td width="35%">Due Date:</td>
										<td width="10%">:</td>
										<td>
											{{
												this.feesNoticeHeaderData
													.due_date
											}}
										</td>
									</tr>
								</table>
							</div>
						</div>

						<!-- Study Information -->
						<table class="table table-sm table-striped">
							<thead>
								<tr>
									<th
										colspan="8"
										class="text-center bold-primary-header"
									>
										Study Information
									</th>
								</tr>
								<tr>
									<th
										rowspan="2"
										class="regular-primary-header"
									>
										Class Name <br />
									</th>
									<th
										rowspan="2"
										class="regular-primary-header"
									>
										Product ID <br />
									</th>
									<th
										rowspan="2"
										class="regular-primary-header"
									>
										Monday <br />
										星期一
									</th>
									<th
										rowspan="2"
										class="regular-primary-header"
									>
										Tuesday <br />
										星期二
									</th>
									<th
										rowspan="2"
										class="regular-primary-header"
									>
										Wednesday <br />
										星期三
									</th>
									<th
										rowspan="2"
										class="regular-primary-header"
									>
										Thursday <br />
										星期四
									</th>
									<th
										rowspan="2"
										class="regular-primary-header"
									>
										Friday <br />
										星期五
									</th>
									<th
										rowspan="2"
										class="regular-primary-header"
									>
										Saturday <br />
										星期六
									</th>
								</tr>
							</thead>
							<tbody>
								<!-- Repeat for each class -->
								<tr
									v-for="(
										data, index
									) in studyInformationData"
									:key="index"
								>
									<td class="text-center">
										{{
											data.schedule_recommendation_id
												.course_id.course_name
										}}
									</td>
									<td class="text-center">
										{{
											data.schedule_recommendation_id
												.product_id.name
										}}
									</td>
									<td class="text-center">
										{{
											data.schedule_recommendation_id
												.time_1 != ""
												? data
														.schedule_recommendation_id
														.time_1
												: "-"
										}}
									</td>
									<td class="text-center">
										{{
											data.schedule_recommendation_id
												.time_2 != ""
												? data
														.schedule_recommendation_id
														.time_2
												: "-"
										}}
									</td>
									<td class="text-center">
										{{
											data.schedule_recommendation_id
												.time_3 != ""
												? data
														.schedule_recommendation_id
														.time_3
												: "-"
										}}
									</td>
									<td class="text-center">
										{{
											data.schedule_recommendation_id
												.time_4 != ""
												? data
														.schedule_recommendation_id
														.time_4
												: "-"
										}}
									</td>
									<td class="text-center">
										{{
											data.schedule_recommendation_id
												.time_5 != ""
												? data
														.schedule_recommendation_id
														.time_5
												: "-"
										}}
									</td>
									<td class="text-center">
										{{
											data.schedule_recommendation_id
												.time_6 != ""
												? data
														.schedule_recommendation_id
														.time_6
												: "-"
										}}
									</td>
								</tr>
							</tbody>
						</table>

						<!-- Fees Notices Details -->
						<table class="table table-sm table-striped">
							<thead>
								<tr>
									<th
										colspan="8"
										class="text-center bold-primary-header"
									>
										Fees Notice Details
									</th>
								</tr>
								<tr>
									<th
										class="regular-primary-header text-center"
									>
										Date
									</th>
									<th
										class="regular-primary-header text-center"
									>
										Description
									</th>
									<th
										class="regular-primary-header text-center"
									>
										Charges (Rp)
									</th>
									<th
										class="regular-primary-header text-center"
									>
										Credits (Rp)
									</th>
									<th
										class="regular-primary-header text-center"
									>
										Balance (RP)
									</th>
								</tr>
							</thead>
							<tbody>
								<!-- Repeat for each fee detail -->
								<tr
									v-for="(
										data, index
									) in feesNoticeDetailsData"
									:key="index"
								>
									<td>{{ data.date }}</td>
									<td
										:style="
											data.product_id.name ==
												'Total Charges' ||
											data.product_id.name ==
												'Total Deductions' ||
											data.product_id.name ==
												'Balance Due' ||
											data.product_id.name ==
												'Admin Fee' ||
											data.product_id.name
												.toLowerCase()
												.includes('tax') ||
											data.product_id.name ==
												'Grand Total'
												? 'text-align: right; font-weight: bold'
												: ''
										"
									>
										{{ data.product_id.name }}
									</td>
									<td style="text-align: right">
										{{ data.debit }}
									</td>
									<td style="text-align: right">
										{{ data.credit }}
									</td>
									<td style="text-align: right">
										{{ data.balance }}
									</td>
								</tr>
							</tbody>
						</table>

						<div class="row">
							<!-- List Notes -->
							<div class="col-md-8">
								<b><p>Note:</p></b>
								<ul>
									<li>
										Please use the provided Virtual Account
										No. to make payment.
									</li>
									<li>
										All fees are NON-REFUNDABLE AND
										NON-TRANSFERABLE
									</li>
									<li>
										Course fee varies depending on class
										level and product name.
									</li>
									<li>
										Full payment must be made before the due
										date.
									</li>
									<li>
										Admin or other fees may be applicable
									</li>
									<li>
										For inquiries, please get in touch with
										us at Info CLC 08994000085.
									</li>
								</ul>
							</div>
							<!-- Payment To -->
							<div class="col-md-3">
								<table class="table table-sm table-bordered">
									<tr>
										<td class="bigger-text">
											Please Make Payment To
										</td>
									</tr>
									<tr>
										<td
											class="smaller-text"
											v-html="bankLogoHtml"
										></td>
									</tr>
									<tr>
										<td class="smaller-text">
											{{
												invoiceData.bank_account_id
													? invoiceData
															.bank_account_id
															.bank_account_virtual_no
													: "no-va-account"
											}}
										</td>
									</tr>
								</table>
							</div>
						</div>
					</div>

					<!-- Footer Section -->
					<div class="card-footer">
						<div class="row">
							<div class="col-md-12">
								<p
									class="text-center"
									style="font-size: 18px; margin-bottom: 5px"
								>
									<b>HELLO CLC</b>
									<a
										href="https://api.whatsapp.com/send?phone=6289611177730&text=Hello%20CLC%20I%20have%20a%20question%20about%20my%20fees%20notice"
										target="_blank"
										rel="noopener noreferrer"
										style="
											text-decoration: none;
											color: inherit;
										"
									>
										<img
											src="https://img.icons8.com/color/48/000000/whatsapp--v1.png"
											alt="whatsapp"
											width="30"
											style="vertical-align: middle"
										/>
										<b>0896 111 777 30 (WA Only)</b>
									</a>
								</p>
							</div>
							<div class="col-md-12">
								<p
									class="text-center"
									style="font-size: 18px; margin-top: 5px"
								>
									<b
										>Join CLC 0896 0686 0062 - Info CLC 0899
										4000 85 - www.clc.co.id</b
									>
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { urlGenerator } from "../../../../../../../../Helpers/AxiosHelper";

export default {
	name: "InvoiceProcess",
	data() {
		return {
			urlGenerator,
			id: null,
			invoiceData: {},
			studyInformationData: [],
			feesNoticeDetailsData: [],
			feesNoticeHeaderData: [],
			bankLogoHtml: "",
		};
	},
	created() {
		let url = window.location.href;
		this.id = parseInt(url.split("/").slice(-1)[0].split("?")[0]);

		this.fetchData();
	},
	methods: {
		async fetchData() {
			try {
				let [
					invoiceDataResponse,
					studyInformationResponse,
					feesNoticeDetailsResponse,
					feesNoticeHeaderResponse,
				] = await Promise.all([
					axios.get(`/transaction/invoice/${this.id}`),
					axios.get(
						`/transaction/invoice-item?invoice_id=${this.id}`
					),
					axios.get(
						`/transaction/invoice/${this.id}/fee-notice-details`
					),
					axios.get(
						`/transaction/invoice/${this.id}/fee-notice-header`
					),
				]);

				this.invoiceData = invoiceDataResponse.data;
				this.studyInformationData = studyInformationResponse.data.data;
				this.feesNoticeDetailsData =
					feesNoticeDetailsResponse.data.data;
				this.feesNoticeHeaderData = feesNoticeHeaderResponse.data;

				this.bankLogoHtml = this.invoiceData.bank_account_id?.bank_id
					? `<img src="${this.urlGenerator(
							this.invoiceData.bank_account_id.bank_id.bank_logo
					  )}" alt="logo" width="100" />`
					: `<img src="https://dummyimage.com/150x100/000/fff&text=no-bank-logo" alt="logo" width="100" />`;

				// Custom sorting function
				this.feesNoticeDetailsData.sort((a, b) => {
					if (a.credit === "0.00" && b.credit !== "0.00") {
						return -1; // Place a before b if a has credit 0 and b doesn't
					} else if (a.credit !== "0.00" && b.credit === "0.00") {
						return 1; // Place b before a if b has credit 0 and a doesn't
					} else if (a.debit === "0.00" && b.debit !== "0.00") {
						return -1; // If both have credit 0, place a before b if a has debit 0 and b doesn't
					} else if (a.debit !== "0.00" && b.debit === "0.00") {
						return 1; // If both have credit 0, place b before a if b has debit 0 and a doesn't
					} else {
						return 0; // Maintain the current order if both have non-zero values for credit and debit
					}
				});

				// add total charges and total credits to this.feesNoticeDetailsData
				let totalChargesObj = {
					balance: 0,
					credit: 0,
					debit: this.invoiceData.total_charges,
					product_id: {
						name: "Total Charges",
					},
					qty: 1,
				};
				// count total data with credit = 0
				let totalCredit0 = this.feesNoticeDetailsData.filter(
					(data) => data.credit == 0
				).length;
				// insert total charges after total data with credit = 0
				this.feesNoticeDetailsData.splice(
					totalCredit0,
					0,
					totalChargesObj
				);

				// add total deductions to this.feesNoticeDetailsData
				let totalDeductionsObj = {
					balance: 0,
					credit:
						this.invoiceData.total_deductions != 0
							? this.invoiceData.total_deductions
							: "",
					debit: 0,
					product_id: {
						name: "Total Deductions",
					},
					qty: this.invoiceData.total_deductions != 0 ? 1 : "",
				};
				let totalDebit0 =
					this.feesNoticeDetailsData.filter((data) => data.debit == 0)
						.length + totalCredit0;
				if (this.invoiceData.total_deductions == 0) {
					totalDebit0 = this.feesNoticeDetailsData.findIndex(
						(data) => data.product_id?.name == "Total Charges"
					);
					// insert total deductions after total charges
					this.feesNoticeDetailsData.splice(
						totalDebit0 + 1,
						0,
						totalDeductionsObj
					);
				} else {
					// insert total deductions after total data with debit = 0
					this.feesNoticeDetailsData.splice(
						totalDebit0 + 1,
						0,
						totalDeductionsObj
					);
				}

				// loop this.feesNoticeDetailsData and console.log index, debit and credit
				// for (let i = 0; i < this.feesNoticeDetailsData.length; i++) {
				// 	console.log(i, this.feesNoticeDetailsData[i].product_id?.name, this.feesNoticeDetailsData[i].debit, this.feesNoticeDetailsData[i].credit);
				// }
				// console.log(this.feesNoticeDetailsData.filter((data) => data.credit == 0).length)
				// console.log(this.feesNoticeDetailsData.filter((data) => data.debit == 0).length)
				// console.log(this.feesNoticeDetailsData.findIndex((data) => data.product_id?.name == 'Total Charges'))

				// add balance due to this.feesNoticeDetailsData
				let balanceDueObj = {
					balance:
						this.invoiceData.total_charges -
						this.invoiceData.total_deductions,
					credit: 0,
					debit: 0,
					product_id: {
						name: "Balance Due",
					},
					qty: 1,
				};
				this.feesNoticeDetailsData.push(balanceDueObj);

				// add tax to this.feesNoticeDetailsData
				let taxObj = {
					balance: 0,
					credit: 0,
					debit: this.invoiceData.vat_amount,
					product_id: {
						name:
							"Tax (" +
							parseFloat(this.invoiceData.vat_percent) +
							"%)",
					},
					qty: 1,
				};
				this.feesNoticeDetailsData.push(taxObj);

				// add admin fee to this.feesNoticeDetailsData
				let adminFeeObj = {
					balance: 0,
					credit: 0,
					debit: parseFloat(this.invoiceData.admin_fee),
					product_id: {
						name: "Admin Fee",
					},
					qty: 1,
				};
				this.feesNoticeDetailsData.push(adminFeeObj);

				// add grand total to this.feesNoticeDetailsData
				let grandTotalObj = {
					balance: this.invoiceData.grand_total,
					credit: 0,
					debit: 0,
					product_id: {
						name: "Grand Total",
					},
					qty: 1,
				};
				this.feesNoticeDetailsData.push(grandTotalObj);

				this.feesNoticeDetailsData.forEach((data) => {
					if (
						(data.debit != 0 || data.credit != 0) &&
						data.balance != 0
					) {
						data.balance = 0;
					}
					data.debit =
						data.debit != 0 ? this.formattedIDR(data.debit) : "";
					data.credit =
						data.credit != 0 ? this.formattedIDR(data.credit) : "";
					data.balance =
						data.balance != 0
							? this.formattedIDR(data.balance)
							: "";
				});

				this.feesNoticeHeaderData.sub_total = this.formattedIDR(
					this.invoiceData.grand_total
				);
			} catch (error) {
				console.error("Error fetching data:", error);
			}
		},
		formattedIDR(value) {
			// Format the value as IDR
			return new Intl.NumberFormat("id-ID", {
				style: "currency",
				currency: "IDR",
				minimumFractionDigits: 0,
			}).format(value);
		},
	},
	watch: {},
};
</script>

<style scoped>
.bold-primary-header {
	background-color: #0056b3; /* A deeper shade of primary color */
	color: white;
}

.regular-primary-header {
	background-color: #007bff; /* Bootstrap's standard primary color */
	color: white;
	text-align: center;
	vertical-align: middle;
}
.custom-container {
	max-width: 900px; /* Adjust the value to your desired container width */
	margin: 0 auto; /* Center the container on the page */
}

.bigger-text {
	font-size: 26px;
	text-align: center;
	font-weight: bold;
}

.smaller-text {
	font-size: 18px;
	text-align: center;
}
</style>
